// extracted by mini-css-extract-plugin
module.exports = {"el":"Chart_el__tbAZu","title":"Chart_title__4yP8U","responsiveContainer":"Chart_responsiveContainer__TH3Ge"};